import { Link } from 'react-router-dom';
import { ServerCrash, Home } from 'lucide-react';
import { ROUTES } from '@constants';
import Button from '@components/common/Button';

const ServerErrorPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <ServerCrash className="w-24 h-24 text-secondary-600 mx-auto mb-6" />
        <h1 className="text-6xl font-bold text-primary-700 mb-4">500</h1>
        <h2 className="text-3xl font-bold text-primary-700 mb-4">Server Error</h2>
        <p className="text-primary-600 mb-8 max-w-md">
          Something went wrong on our end. Please try again later.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to={ROUTES.HOME}>
            <Button variant="primary" size="lg">
              <Home className="w-5 h-5 mr-2" />
              Go Home
            </Button>
          </Link>
          <Button variant="outline" size="lg" onClick={() => window.location.reload()}>
            Reload Page
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServerErrorPage;
